
import { Binoculars, Images, FileText, BarChart3, Calendar, Bot, PenTool, Building2, NotebookTabs, ListTodo, ChartNoAxesCombined, Microscope, Video, Clapperboard, NotebookPen } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export const getIconByName = (iconName: string): LucideIcon => {
  const iconMap: Record<string, LucideIcon> = {
    'Binoculars': Binoculars,
    'Images': Images,
    'FileText': FileText,
    'BarChart3': BarChart3,
    'Calendar': Calendar,
    'Bot': Bot,
    'PenTool': PenTool,
    'Building2': Building2,
    'NotebookTabs': NotebookTabs,
    'ListTodo': ListTodo,
    'ChartNoAxesCombined': ChartNoAxesCombined,
    'Microscope': Microscope,
    'Video': Video,
    'Clapperboard': Clapperboard,
    'NotebookPen': NotebookPen,
  };
  
  return iconMap[iconName] || FileText;
};

export const formatAppStatus = (status: string): string => {
  switch (status) {
    case 'available':
      return 'Available';
    case 'featured':
      return 'Featured';
    case 'coming-soon':
      return 'Coming Soon';
    case 'installed':
      return 'Installed';
    default:
      return 'Unknown';
  }
};
